var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-container',[_c('iframe',{staticStyle:{"border":"none","position":"absolute","top":"0","left":"0","right":"0","bottom":"0"},attrs:{"height":"100%","width":"100%","scrolling":"no","src":_vm.query.url}})])
}
var staticRenderFns = []

export { render, staticRenderFns }